import classnames from 'classnames'
import { CardPro } from '../CardPro'
import Subscription from '../Subscription'
import { Disclaimer } from '../Disclaimer/Disclaimer'
import { FooterText } from '../FooterText/FooterText'
import { HousingType } from '../HousingType/HousingType'
import { ROUTE_KEY_HOME, ROUTE_KEY_BUY } from '../../../constants/routes'
import styles from './Footer.module.scss'

export type FooterProps = {
  className?: string
  reportType: typeof ROUTE_KEY_BUY | typeof ROUTE_KEY_HOME
}

export const Footer = ({ className, reportType }: FooterProps) => {
  return (
    <footer className={classnames(styles.root, className)}>
      <CardPro />
      <Subscription reportType={reportType} />
      <hr className={styles.divider} />
      <div className={styles.twoColumn}>
        <div className={styles.leftColumn}>
          <Disclaimer />
        </div>
        <div className={styles.rightColumn}>
          <HousingType />
          <FooterText />
        </div>
      </div>
    </footer>
  )
}
